import Header from "../global/Components/Header";
import Footer from "../global/Components/Footer";
import Main from "../components/Main"

export default function Layout({children}) {
  return (
    <>
      <Header />
      <Main>
        {children}
      </Main>
      <Footer />
    </>
  )
}
